/**
 * Created by mykurisu on 2017/11/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import qr from 'qr-encode'
import '../../css/common/DeepFocusBar.css'
import FingerIcon from '../../images/deep_focus_bar_icon.png'


class DeepFocusBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            Qrcode: null,
            getingCode: false
        };
        this.el = props.el || window
    }

    componentDidMount() {
        if (!this.props.account.subscribed) {
            this.handleScroll();
            this.el.addEventListener('scroll', () => this.handleScroll())
        }
    }

    componentWillUnmount() {
        this.el.removeEventListener('scroll', () => this.handleScroll())
    }

    handleScroll() {
        if (this.bar && this.bar.getBoundingClientRect().top <= 800 && !this.state.Qrcode){
            if (!this.props.account.subscribed && !this.state.getingCode) {
                this.setState({
                    getingCode: true
                });
                axios.get(`/api/liveroom/${this.props.liveroom_id}/get_qrcode`, {
                    params: {
                        object_id: this.props.object_id,
                        object_type: this.props.object_type
                    }
                })
                    .then(res => {
                        if (res.data.code === 0) {
                            this.setState({
                                Qrcode: res.data.data.qrcode_content,
                                getingCode: false
                            })
                        }
                    })
            }
        }
    }


    render() {
        if (this.props.account.subscribed) {
            return null
        }

        return (
            <div className="deepfocus__bar" ref={r => this.bar = r}>
                <div className="bar__qrcode">
                    {this.state.Qrcode &&
                    <img src={qr(this.state.Qrcode)}/>
                    }
                </div>

                <div className="bar__message">
                    <p>长按扫码关注，接收直播间消息</p>
                    <p>听课赚钱两不误</p>
                </div>

                <div className="bar__somedeco">
                    <img src={FingerIcon} alt=""/>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    account: state.account,
}))(DeepFocusBar)



// WEBPACK FOOTER //
// ./src/components/details/DeepFocusBar.js